import Api from "../../utils/axios";

const OrderApi = {
  getAllOrders: (payload,search="") => Api.post(`order/get-all-orders?search=${search}`,payload), 
  getAllFoodOrders: (payload,search="") => Api.post(`food-order/get-all-orders?search=${search}`,payload), 
  updateOrders: (payload) => Api.put(`order/update-order`,payload),  
};

export default OrderApi;


export const reviewApi={
  // product review apis
  getAllVendorReviews: (payload,search="") => Api.post(`order/get-all-vendor-review?search=${search}`,payload),  
  getAllProductReviews: (payload,search="") => Api.post(`order/get-all-product-review?search=${search}`,payload),  
  getReviewsByCustomer: (payload,search="") => Api.post(`user/get-customer-rating-review?search=${search}`,payload),  
  hideComment: (reviewId,payload) => Api.put(`admin/hide-vendor-comment/${reviewId}`,payload),  

  // finance and funding review apis
  getAllFinanceReviews: (payload, search = "") => Api.post(`order/get-all-finance-rating-review?search=${search}`, payload),
  replyToCustomer: (reviewId, payload) => Api.post(`admin/finance-review-reply/${reviewId}`,payload),
}